// =============================================================================
// src/core/carto-tiles.ts — Basemap legado CartoDB para telas fora da aba Mapa.
//
// Reintroduz o tileset escuro anterior onde o produto pediu "mapa antigo"
// (Cinema). Desde 2026-10-13 o Explorar tambem usa OSM (src/core/osm-tiles.ts),
// entao o CartoDB light saiu daqui; fica so o dark do Modo Cinema.
//
// Proveniencia: URL original do ExploreMap antes de 8128ed6. O template
// `{s}/{z}/{x}/{y}{r}` e `subdomains` seguem a API L.tileLayer validada nos docs
// Context7 de Leaflet (/leaflet/leaflet, 2026-06-07).
// =============================================================================

/** URL do tileset escuro legado usado pelo mapa antigo do Modo Cinema. */
export const LEGACY_CARTO_DARK_TILE_URL =
  'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';

/** Subdominios do CartoDB usados pelo template `{s}` do tileset legado. */
export const LEGACY_CARTO_SUBDOMAINS = 'abcd';

/** Zoom maximo historico do tileset legado. */
export const LEGACY_CARTO_MAX_ZOOM = 19;
